export default {"src":"/_next/static/media/creditcheck.65efd9ec.svg","height":51,"width":50};